const RICOS_VERSION = "10.123.1";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
